// @mui material components
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { styled } from "@mui/material/styles";

export default styled(({ ...props }) => (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker format="YYYY-MM-DD" {...props} />
    </LocalizationProvider>
))(({ ownerState }) => ({
    backgroundColor: ownerState.bgColor || 'transparent',
    color: ownerState.color || 'inherit',
    borderRadius: ownerState.borderRadius || '4px',
    boxShadow: ownerState.shadow || 'none',
    opacity: ownerState.opacity || 1,
    border: 'none',
    outline: 'none',

    '& .MuiInputBase-root': {
        '&:focus': {
            outline: 'none',
            border: 'none',
        },
        '&.MuiOutlinedInput-root': {
            '& fieldset': {
                border: 'none',
            },
        },
    },
}));
